import { FilterQuery, YesObject } from '@yes.technology/react-toolkit'
import { CSSProperties } from 'react'
import { FieldSettings } from 'shared/types'
import { z } from 'zod/v4'
import { PaginationSchema } from '../sharedSchemas'
import createComponentSchema from '../util/createComponentSchema'

export const CustomActionButtonSchema = z.object({
  label: z.string(),
  link: z.object({
    url: z.string(),
    target: z.string().optional()
  }),
  style: z.custom<CSSProperties>().optional(),
  interpolation_fields: z.array(z.string()).optional()
})

const RelationActionSchema = z.object({
  relationName: z.string(),
  link: z
    .object({
      target: z.string().optional(),
      url: z.string().optional()
    })
    .optional(),
  label: z.string().optional(),
  style: z.custom<CSSProperties>().optional()
})

export const MapColumnToActionSchema = z.record(
  z.string(),
  RelationActionSchema
)

export const TableActionsVisibilitySchema = z.object({
  insert: z.boolean().optional(),
  edit: z.boolean().optional(),
  document_upload: z.boolean().optional()
})

const DataTablesSchema = createComponentSchema(
  'DataTables',
  z.object({
    elementUuid: z.string(),
    uuid_objectclass: z.string(),
    uuid_layout_classification: z.string().optional(),
    uuid_filteraction: z.string().optional(),
    objectclassQueryString: z.string().optional(),
    informational: z.boolean().optional(),
    concat_fields: z.record(z.string(), z.string()).optional(),
    hide_row_action_buttons: z.boolean().optional(),
    hide_main_collapsible_container: z.boolean().optional(),
    hide_sort_buttons: z.boolean().optional(),
    allow_highlight_selected_row: z.boolean().optional(),
    merge_filter_query: z.custom<FilterQuery>().optional(),
    field_settings: z.custom<FieldSettings>().optional(),
    is_show_title: z.boolean().optional(),
    is_show_reports: z.boolean().optional(),
    is_show_xls_report: z.boolean().optional(),
    is_collapsible_card: z.boolean().optional(),
    objects: z.array(z.custom<YesObject>()).optional(),
    custom_action_buttons: z
      .record(z.string(), CustomActionButtonSchema)
      .optional(),
    navigationslider_background_color: z.string().optional(),
    navigationslider_color: z.string().optional(),
    allow_collapsible_navigation_card_custom_colors: z.boolean().optional(),
    hide_collapsible_card_arrow: z.boolean().optional(),
    initial_pagination: PaginationSchema.optional(),
    map_column_to_action: MapColumnToActionSchema.optional(),
    isolate_filter_query: z.boolean().optional(),
    text_fading: z.boolean().optional(),
    nav_sticky: z.boolean().optional(),
    table_actions_visibility: TableActionsVisibilitySchema.optional(),
    upload_accepted_file_types: z.string().optional(),
    stabilize_table_layout_during_load: z.boolean().optional()
  })
)

export default DataTablesSchema
